export default {
    import: "Export File",
    peopleBook: "Number of People Booked",
    booked: "Number of Bookings",
    clickHere: "Click here to view details",
    updated: "Update Appointment",
    btn: {
        creat: "Create",
        creatFund: "Create Fund",
        pagination: "Rows per page",
    },

    tapList: {
        total: "All",
        active: "Active",
        inactive: "Inactive",
        pending: "Pending Approval",
        reject: "Rejected",
        draft: "Draft",
    },
    tapManage: {
        all: "All Candidates",
        waiting: "Waiting",
        rejectbook: "Rejected",
        pending: "Pending",
        passed: "Passed",
        notPass: "Not Passed",
        missed: "Missed",
    },

    tapManage_consult: {
        all: "All Candidates",
        waiting: "Waiting",
        rejectbook: "Rejected",
        pending: "Pending",
        passed: "Passed",
        notPass: "Not Passed",
        missed: "Missed",
    },

    header: {
        updatedAt: "Last Updated",
        jopPo: "Table Details",
        jopPoFund: "Fund Details",
        appAmount: "Amount",
        status: "Status",
    },

    amount: {
        all: "Total",
        appAll: "Total Applicants",
        notViewedResume: "Resume Not Viewed",

        booking: "Booking",
        applyJob: "Apply Job",
    }
};